import { Button, ButtonGroup, Heading, ModalDialog, TextButton } from '@zillow/constellation';
import { SubmissionCheckbox } from './SubmissionCheckbox';
import { getIsAnswersComplete } from '../../utils/overview/overview-statuses';
import { useApplicationContext } from '../../contexts/ApplicationContext';

interface Props {
  givesPermission: boolean;
  setGivesPermission: (givesPermission: boolean) => void;
  onClose: () => void;
  onClickSubmit: () => void;
  loading: boolean;
}

// Shows when the user clicks submit but the checkbox has not been checked
export function SubmitModal({ givesPermission, setGivesPermission, onClose, onClickSubmit, loading }: Props) {
  const applicationContext = useApplicationContext();
  const { application } = applicationContext;
  const isComplete = getIsAnswersComplete(applicationContext, false);

  return (
    <ModalDialog
      isOpen
      onClose={onClose}
      size={{ default: 'fullScreen', md: 'lg' }}
      renderHeader={
        <Heading level={6} as="h1">
          Submit application
        </Heading>
      }
      renderBody={
        <>
          <Heading level={6} as="h2">
            Before you submit your application, you’ll need to accept the following terms:
          </Heading>
          <SubmissionCheckbox
            givesPermission={givesPermission}
            setGivesPermission={setGivesPermission}
            listingOwnerName={application.listingOwner?.name || ''}
            rentalListing={application.rentalListing || {}}
            disabled={!isComplete}
          />
        </>
      }
      renderFooter={
        <ButtonGroup aria-label="Submit application">
          <TextButton onClick={onClose} disabled={loading} type="button">
            Cancel
          </TextButton>
          <Button buttonType="primary" onClick={onClickSubmit} disabled={loading || !givesPermission}>
            Submit application
          </Button>
        </ButtonGroup>
      }
    />
  );
}
